(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  function init(root) {
    if (root.__teakHcInit) return;
    root.__teakHcInit = true;

    var count = parseInt(root.getAttribute('data-teak-hover-count'), 10);
    if (!count || count < 2) return;

    var images = root.querySelectorAll('.teak-hc__img');
    var dashes = root.querySelectorAll('.teak-hc__dash');
    var indicator = root.querySelector('[data-teak-hover-indicator]');

    if (indicator) {
      indicator.dataset.active = '1';
      indicator.dataset.count = String(count);
    }

    function setActive(zone) {
      images.forEach(function (img, i) {
        img.classList.toggle('is-active', i === zone - 1);
      });
      dashes.forEach(function (d, i) {
        d.classList.toggle('is-active', i === zone);
      });
      if (indicator) indicator.dataset.active = String(zone + 1);
    }

    function clear() {
      images.forEach(function (img) { img.classList.remove('is-active'); });
      dashes.forEach(function (d) { d.classList.remove('is-active'); });
    }

    root.addEventListener('mouseenter', function () {
      root.classList.add('is-hovering');
      setActive(0);
    });
    root.addEventListener('mousemove', function (e) {
      var rect = root.getBoundingClientRect();
      if (rect.width <= 0) return;
      var x = e.clientX - rect.left;
      var zone = Math.floor((x / rect.width) * count);
      if (zone < 0) zone = 0;
      if (zone > count - 1) zone = count - 1;
      setActive(zone);
    });
    root.addEventListener('mouseleave', function () {
      root.classList.remove('is-hovering');
      clear();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-teak-hover-cycle]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Observe the body for dynamically inserted elements (e.g. infinite scroll, search, recommendations)
  if (window.MutationObserver) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (!mutation.addedNodes) return;
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return; // Only element nodes
          if (node.matches && node.matches('[data-teak-hover-cycle]')) {
            init(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('[data-teak-hover-cycle]').forEach(init);
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
